import { z } from 'zod';
// User schema - example shared validation
export const UserSchema = z.object({
    id: z.guid(),
    email: z.string().email(),
    name: z.string().min(1).max(100),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
// API response wrapper schema
export const ApiResponseSchema = (dataSchema) => z.object({
    success: z.boolean(),
    data: dataSchema.optional(),
    error: z
        .object({
        code: z.string(),
        message: z.string(),
    })
        .optional(),
});
// Auth schemas
export const LoginRequestSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8),
});
export const LoginResponseSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    expiresIn: z.number(),
});
// Theme schemas
export { CssColorValueSchema, ThemeColorTokensSchema, ThemeDefinitionSchema, ThemeImportSchema, ThemeMetaSchema, UserThemePreferencesSchema, CommunityThemeUploadSchema, } from './theme';
// Space schemas
export { SpaceVisibilitySchema, SpaceSlugSchema, CipherCheckSchema, SpaceCipherJoinProofSchema, CreateSpaceSchema, CreateSpaceEncryptedSeedSchema, UpdateSpaceSchema, SpaceThemeSchema, UPDATE_SPACE_PROFILE_FIELDS, UPDATE_SPACE_THEME_FIELDS, UPDATE_SPACE_SETTINGS_FIELDS, CreateSpaceInviteSchema, CreateSpaceInviteLinkSchema, SpaceTemporaryAccessSchema, SpaceInviteCodeSchema, SendSpaceMessageSchema, EditSpaceMessageSchema, AddSpaceReactionSchema, PinSpaceMessageSchema, MarkSpaceChannelReadSchema, CreateSpaceRoleSchema, UpdateSpaceRoleSchema, ReorderSpaceRolesSchema, SetMemberRolesSchema, BanSpaceMemberSchema, UpdateSpaceMemberProfileSchema, UpdateSpacePreferencesSchema, SpaceActivityPreferencesSchema, UpdateSpaceActivitySettingsSchema, SpaceNotifyLevelSchema, SpaceNotificationOverridesPatchSchema, SpaceNotificationDefaultsSchema, NotificationDisplaySettingsSchema, CreateSpaceChannelSchema, UpdateSpaceChannelSchema, CreateSpaceChannelCategorySchema, UpdateSpaceChannelCategorySchema, UpdateSpaceChannelLayoutSchema, SetSpaceRolePermissionOverridesSchema, SpaceAnnouncementAudienceSchema, CreateSpaceAnnouncementSchema, EditSpaceAnnouncementSchema, ListSpaceAnnouncementsQuery, } from './spaces';
export { ListInviteInboxQuerySchema, parseListInviteInboxQuery, InviteInboxBucketSchema, InviteInboxSortSchema, InviteInboxSortDirSchema, } from './invite-inbox';
export { ListSpaceInviteHistoryQuerySchema, parseListSpaceInviteHistoryQuery, ListSpaceInviteLinkRedemptionsQuerySchema, parseListSpaceInviteLinkRedemptionsQuery, SpaceInviteHistoryStatusSchema, SpaceInviteHistorySortSchema, SpaceInviteHistorySortDirSchema, } from './space-invite-history';
export { KickSpaceMemberSchema, CreateSpaceMemberNoteSchema, UpdateSpaceMemberNoteSchema, } from './space-member-directory';
// Re-export zod for convenience
export { z };
//# sourceMappingURL=index.js.map